/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  loaded: false,
  highlighted: [],
  labelLayer: null
}

const getters = {
  /**
   * Whether MapBox has loaded
   */
  ready: state => state.loaded,

  /**
   * Get the id of the highlighted hexagon
   */
  getHighlighted: state => state.highlighted,
  /**
   * The first label layer. We want to add our layers below this one
   */
  labelLayer: state => state.labelLayer
}
const actions = {

}
const mutations = {
  setLoaded(state, { loaded }) {
    state.loaded = loaded
  },
  setHighlighted(state, { fids }) {
    state.highlighted = fids
  },
  setLabelLayer(state, { id }) {
    state.labelLayer = id
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
